/* Draft-only navigation enhancement; existing destinations and shared menu data are preserved. */
(() => {
  'use strict';
  const init = () => {
    const config = document.querySelector('#gl2-menu-config');
    const nav = document.querySelector('#AccessibleNav');
    const drawer = document.querySelector('#NavDrawer');
    const header = nav?.closest('.header-section--wrapper');
    if (!config || !header || !drawer || header.classList.contains('gl2-navigation') || document.body.classList.contains('gl-living-page')) return;
    header.classList.add('gl2-navigation');
    const desktop = window.matchMedia('(min-width:990px)');
    const labels = config.dataset;
    const triggers = [...header.querySelectorAll('.js-drawer-open-left-link')];
    const closeMobile = drawer.querySelector('.mobile-menu--close-btn');
    const brand = () => config.content.cloneNode(true);
    const sheet=document.createElement('dialog');sheet.id='gl2-gallery-menu';sheet.className='gl2-gallery-menu';sheet.setAttribute('aria-label',labels.menu);
    const opener=document.createElement('button');opener.type='button';opener.className='gl2-gallery-opener';opener.textContent=labels.explore;opener.setAttribute('aria-controls',sheet.id);opener.setAttribute('aria-expanded','false');opener.setAttribute('aria-haspopup','dialog');
    const initial=nav.closest('.gl2-menu-initial');
    const restoreOpenerFocus=initial?.contains(document.activeElement);
    if(initial)initial.before(opener);else nav.before(opener);
    sheet.append(brand(),nav);header.querySelector('.site-header').append(sheet);
    initial?.remove();
    if(restoreOpenerFocus)opener.focus({preventScroll:true});

    // Fill gaps between homepage and inner menus without changing shared menus.
    const menuEnglish=document.documentElement.lang.toLowerCase().startsWith('en');
    const sharedChoices=[{"anchor":"baby-plants","gr":"Σαρκοφάγα φυτά","en":"Carnivorous plants","hrefGr":"/collections/carnivorous-plants","hrefEn":"/en-eu/collections/carnivorous-plants"},{"anchor":"acer","gr":"Magnolia","en":"Magnolia","hrefGr":"/collections/magnolia%C2%AE","hrefEn":"/en-eu/collections/magnolia%c2%ae"},{"anchor":"acer","gr":"Hibiscus","en":"Hibiscus","hrefGr":"/collections/hibiscus%C2%AE","hrefEn":"/en-eu/collections/hibiscus%c2%ae"},{"anchor":"special-collection","gr":"Echeveria","en":"Echeveria","hrefGr":"/collections/echeverias","hrefEn":"/en-eu/collections/planning"},{"anchor":"special-collection","gr":"Mystery Box","en":"Mystery Box","hrefGr":"/collections/mystery-box","hrefEn":"/en-eu/collections/mystery-box"},{"anchor":"orchid-pots","gr":"Γλάστρες για παχύφυτα","en":"Succulent pots","hrefGr":"/collections/suculentpots","hrefEn":"/en-eu/collections/succuulent-pots"}];
    const relabel=(element,text)=>{
      const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT);
      let node;while((node=walker.nextNode())){if(node.textContent.trim()&&!node.parentElement.closest('[aria-hidden="true"],svg')){node.textContent=text;break;}}
    };
    for(const area of [nav,drawer]){
      for(const choice of sharedChoices){
        const source=[...area.querySelectorAll('a[href]')].find(a=>decodeURIComponent(new URL(a.href,location.origin).pathname).includes('/collections/'+choice.anchor));
        const list=source?.closest('ul');
        if(!list)continue;
        const href=menuEnglish?choice.hrefEn:choice.hrefGr;
        if([...list.querySelectorAll('a[href]')].some(a=>a.getAttribute('href')===href))continue;
        const item=document.createElement('li');
        if(area===drawer)item.className='mobile-nav__item';
        const link=document.createElement('a');link.href=href;
        if(area===drawer)link.className='mobile-nav__link';
        link.textContent=menuEnglish?choice.en:choice.gr;
        item.append(link);list.append(item);
      }
      area.querySelectorAll('a[href]').forEach(link=>{
        const pathname=new URL(link.href,location.origin).pathname.replace(/\/$/,'');
        if(/\/collections\/(new|new-varieties)$/.test(pathname))relabel(link,menuEnglish?'New arrivals':'Νέες αφίξεις');
        if(link.textContent.trim().toUpperCase()==='HYDROCULTURE')relabel(link,menuEnglish?'HYDROCULTURE':'ΥΔΡΟΚΑΛΛΙΕΡΓΕΙΑ');
      });
    }


    // All indoor plant types share one group; collection shortcuts remain separate.
    for(const area of [nav,drawer]){
      const targetLink=[...area.querySelectorAll('a[href]')].find(a=>a.textContent.trim()==='Monstera');
      const typeList=targetLink?.closest('ul');
      if(!typeList)continue;
      const group=typeList.parentElement;
      const title=group.querySelector(':scope > .gl-catalog-menu__heading,:scope > .mobile-nav__has-sublist > a');
      if(title)relabel(title,menuEnglish?'By plant type':'Ανά είδος');
      for(const handle of ['philodendron','hoya','peperomia','ferns','ferns-plants','carnivorous-plants']){
        const link=[...area.querySelectorAll('a[href]')].find(a=>new URL(a.href,location.origin).pathname.replace(/\/$/,'').endsWith('/collections/'+handle));
        const item=link?.closest('li');
        if(item&&item.parentElement!==typeList)typeList.append(item);
      }
    }

    const categoryImages={"indoor":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-indoor-v2-20261020.png?v=1792469282","outdoor":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-outdoor-v2-20261020.png?v=1792469298","succulents":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-succulents-v1-20261019.png?v=1792435083","hydro":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-hydro-v3-20261020.png?v=1792487683","care":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-care-v4-20261020.png?v=1792477681","gardening":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-gardening-v1-20261019.png?v=1792435146","finder":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-finder-v1-20261019.png?v=1792435161","discover":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-discover-v1-20261019.png?v=1792435177"};
    const categoryKeys=['indoor','outdoor','succulents','hydro',null,'care','gardening','finder','discover'];
    const photos=categoryKeys.map(key=>categoryImages[key]||labels.objects);
    const setPhoto=(img,src)=>{img.alt='';if(src.includes('gl2-category-')){img.width=1672;img.height=941;if(src.includes('care-v4-')){img.width=1536;img.height=1024;}img.src=src+'&width=540';img.srcset=[360,540,720,1080].map(w=>src+'&width='+w+' '+w+'w').join(', ');img.sizes='(max-width:460px) calc(150vw - 66px), 624px';}else{img.src=src;img.removeAttribute('srcset');}};
    const photograph=(src,className)=>{const figure=document.createElement('figure');figure.className=className;figure.setAttribute('aria-hidden','true');const img=document.createElement('img');img.alt='';img.width=720;img.height=960;img.loading='lazy';img.decoding='async';setPhoto(img,src);figure.append(img);return figure;};

    // Editorial scenes composed from the existing catalogue product photographs.
    const sceneImages={"mica®":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-mica-v3-20261019.png?v=1792429539","capi":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-capi-v6-20261020.png?v=1792490946","lechuza":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-lechuza-v3-20261019.png?v=1792429825","terraneo":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-terraneo-v3-20261019.png?v=1792429857","globee-pots":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-globee-v6-20261020.png?v=1792487707","hydroculture":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-category-hydro-v3-20261020.png?v=1792487683"};
    const sceneImage=src=>{
      const img=document.createElement('img');img.className='gl2-scene-image';img.alt='';img.width=1448;img.height=1086;img.loading='lazy';img.decoding='async';
      const immersive=src.includes('gl2-pots-immersive-')||src.includes('gl2-category-');if(immersive){img.width=1672;img.height=941;}if(/care-v4-|globee-pots-v5-|capi-v5-|capi-v6-|hydro-v3-|globee-v6-/.test(src)){img.width=1536;img.height=1024;}img.src=src+'&width=720';img.srcset=(immersive?[360,540,720,1080,1448,1672]:[360,540,720,1080,1448]).map(width=>src+'&width='+width+' '+width+'w').join(', ');img.sizes=immersive?'(max-width:989px) 375px, 100vw':'(max-width:989px) 310px, (max-width:1200px) calc(100vw - 532px), (max-width:1558px) calc(81vw - 372px), calc(100vw - 668px)';return img;
    };
    const hydroComposition=()=>{
      const stage=document.createElement('figure');stage.className='gl2-hydro-composition gl2-editorial-scene';stage.setAttribute('aria-hidden','true');stage.append(sceneImage(sceneImages.hydroculture));return stage;
    };
    const potPath=href=>decodeURIComponent(new URL(href,location.origin).pathname).replace(/\/$/,'');
    const tallScenes={"mica®":{"url":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-mica-portrait-20261020.png?v=1792487614","width":1122,"height":1402},"lechuza":{"url":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-lechuza-portrait-20261020.png?v=1792487628","width":1122,"height":1402},"terraneo":{"url":"https://cdn.shopify.com/s/files/1/2962/3312/files/gl2-pots-immersive-terraneo-portrait-20261020.png?v=1792487657","width":1122,"height":1402}};
    const potComposition=key=>{
      const stage=document.createElement('span');stage.className='gl2-pot-composition gl2-editorial-scene';stage.dataset.brand=key;stage.setAttribute('aria-hidden','true');
      const img=sceneImage(sceneImages[key]);
      const tall=tallScenes[key];
      if(tall){
        const picture=document.createElement('picture');picture.className='gl2-pot-art';
        const source=document.createElement('source');source.media='(min-width:990px) and (max-aspect-ratio:6/5)';
        source.srcset=[540,720,1080,tall.width].filter((w,i,a)=>a.indexOf(w)===i).map(w=>tall.url+'&width='+w+' '+w+'w').join(', ');
        source.sizes='(max-width:1200px) calc(100vw - 230px), calc(100vw - 268px)';
        source.width=tall.width;source.height=tall.height;
        picture.append(source,img);stage.append(picture);
      }else stage.append(img);
      return stage;
    };
    let lastScene = null;
    const imageJobs = new WeakMap();
    const sceneFor = panel => panel?.querySelector('.gl-pots-preview__card.is-active img:not(.gl2-scene-hold),.gl2-category-scene img:not(.gl2-scene-hold)');
    const rememberScene = img => {
      if (img?.complete && img.naturalWidth) lastScene = {src:img.currentSrc,width:img.naturalWidth,height:img.naturalHeight};
    };
    const warmImage = img => {
      if (!img || !desktop.matches) return;
      img.fetchPriority = 'low';
      img.loading = 'eager';
    };
    const imageReady = img => {
      if (imageJobs.has(img)) return imageJobs.get(img);
      const job = new Promise(resolve => {
        let settled = false, decoding = false;
        const settle = ok => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          img.removeEventListener('load',finish);
          img.removeEventListener('error',fail);
          resolve(ok);
        };
        const fail = () => settle(false);
        const finish = async () => {
          if (settled || decoding) return;
          if (!img.naturalWidth) { fail(); return; }
          decoding = true;
          try {
            await img.decode();
            settle(Boolean(img.complete && img.naturalWidth));
          } catch { fail(); }
        };
        const timer = setTimeout(fail,10000);
        img.addEventListener('load',finish,{once:true});
        img.addEventListener('error',fail,{once:true});
        img.loading = 'eager';
        if (img.complete) finish();
      });
      imageJobs.set(img,job);
      job.finally(()=>imageJobs.delete(img));
      return job;
    };

    const prepareScene = img => {
      if (!img || !desktop.matches) return;
      if (img.complete && img.naturalWidth) { rememberScene(img); return; }
      const frame = img.closest('.gl2-pot-composition,.gl2-category-scene');
      if (!frame || frame.dataset.gl2Loading === 'true') return;
      frame.dataset.gl2Loading = 'true';
      if (lastScene) {
        const hold = document.createElement('img');
        hold.className = 'gl2-scene-image gl2-scene-hold';
        hold.alt = '';
        hold.setAttribute('aria-hidden','true');
        hold.width = lastScene.width;
        hold.height = lastScene.height;
        hold.src = lastScene.src;
        frame.append(hold);
      }
      img.classList.add('gl2-image-pending');
      img.fetchPriority = 'high';
      imageReady(img).then(ok => {
        img.classList.remove('gl2-image-pending');
        delete frame.dataset.gl2Loading;
        const card = frame.closest('.gl-pots-preview__card');
        if (ok && frame.closest('[data-gl2-open]') && (!card || card.classList.contains('is-active'))) rememberScene(img);
        setTimeout(()=>frame.querySelectorAll('.gl2-scene-hold').forEach(hold=>hold.remove()),220);
      });
    };

    const potCards=[...nav.querySelectorAll('.gl-catalog-menu--pots .gl-pots-preview__card')];
    const potCatalogue=nav.querySelector('.gl-catalog-menu--pots');
    potCards.forEach(card=>{
      const key=card.dataset.potCollection;if(!sceneImages[key])return;
      const label=[...potCatalogue.querySelectorAll('.gl-catalog-menu__primary a')].find(link=>potPath(link.href)===potPath(card.href))?.textContent.trim();
      card.setAttribute('aria-label',label||card.querySelector('img')?.alt||key);
      card.querySelector('.gl-catalog-menu__image-frame').replaceChildren(potComposition(key));
      const caption=document.createElement('span');caption.className='gl2-scene-caption';caption.setAttribute('aria-hidden','true');caption.textContent=label||key;card.append(caption);
      if(card.classList.contains('is-active'))potCatalogue.querySelectorAll('.gl-catalog-menu__primary a').forEach(link=>link.classList.toggle('is-previewed',potPath(link.href)===potPath(card.href)));
    });
    let potSelection = 0;
    const cancelPotSelection = () => {
      potSelection++;
      potCatalogue?.removeAttribute('aria-busy');
    };
    const selectPot = event => {
      if (!desktop.matches) return;
      const link=event.target.closest('.gl-catalog-menu__primary a');
      if(!link)return;
      const selected=potCards.find(card=>potPath(card.href)===potPath(link.href));
      if(!selected)return;
      event.stopPropagation();
      const request=++potSelection;
      const previous=potCards.find(card=>card.classList.contains('is-active'));
      if(previous===selected){potCatalogue.removeAttribute('aria-busy');return;}
      const img=selected.querySelector('img:not(.gl2-scene-hold)');
      if(!img)return;
      potCatalogue.setAttribute('aria-busy','true');
      img.fetchPriority='high';
      // Keep the existing rendered card until the replacement can be painted.
      // A completed download alone does not guarantee an async image is decoded.
      imageReady(img).then(ok=>{
        if(request!==potSelection)return;
        potCatalogue.removeAttribute('aria-busy');
        if(!ok || !desktop.matches || !potCatalogue.closest('[data-gl2-open]'))return;
        rememberScene(previous?.querySelector('img:not(.gl2-scene-hold)'));
        img.classList.remove('gl2-image-pending');
        potCards.forEach(card=>{const active=card===selected;card.classList.toggle('is-active',active);card.setAttribute('aria-hidden',String(!active));card.tabIndex=active?0:-1;});
        potCatalogue.querySelectorAll('.gl-catalog-menu__primary a,.gl-catalog-menu__group a').forEach(item=>item.classList.toggle('is-previewed',item===link));
        rememberScene(img);
      });
    };
    ['focusin','pointerover'].forEach(type=>potCatalogue?.addEventListener(type,selectPot,true));

    const mobilePots=[...drawer.querySelectorAll('.mobile-nav--main>.top-level')].find(item=>item.querySelector('a[href$="/terraneo"]'));
    mobilePots?.classList.add('gl2-mobile-pots');
    mobilePots?.querySelectorAll('a[href]').forEach(link=>{
      // Hash links open a group. Resolving "#" against the current collection
      // otherwise gives parent headings the current brand's photograph.
      if (link.closest('.mobile-nav__has-sublist') || !link.getAttribute('href') || link.getAttribute('href').startsWith('#')) return;
      const card=potCards.find(card=>potPath(card.href)===potPath(link.href));if(!card)return;
      const scene=potComposition(card.dataset.potCollection);
      scene.querySelector('img').sizes='112px';
      link.classList.add('gl2-pot-mobile-link');link.append(scene);
    });
    const shade = document.createElement('button');
    shade.type = 'button'; shade.className = 'gl2-menu-shade'; shade.hidden = true;
    shade.tabIndex = -1; shade.setAttribute('aria-label', labels.close);
    document.body.append(shade);
    let active = null, mobileOpen = false, returnTo = null, locked = false, savedOverflow = '';
    const inertBackground = new Map();
    const focusables = root => [...root.querySelectorAll('a[href],button,[tabindex="0"],input,select')].filter(el => !el.disabled && !el.closest('[hidden],[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
    const lock = enabled => {
      if (enabled && !locked) { savedOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; locked = true; }
      if (!enabled && locked) { document.body.style.overflow = savedOverflow; locked = false; }
    };
    const position = () => {
      const top = Math.max(0, Math.round(nav.getBoundingClientRect().bottom));
      header.style.setProperty('--gl2-top', `${top}px`);
      shade.style.setProperty('--gl2-top', `${top}px`);
    };
    const entries = [...nav.children].map((item,index) => {
      const trigger = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > .mega-menu-dropdown');
      if (!trigger || !panel) return null;
      // This dialog owns its navigation state; keep the legacy hover handler off these entries.
      ['mouseover','touchstart','focusin'].forEach(type=>{
        trigger.addEventListener(type,event=>{if(desktop.matches)event.stopPropagation();});
        panel.addEventListener(type,event=>{if(desktop.matches)event.stopPropagation();});
      });
      panel.id = `gl2-panel-${index}`; panel.inert = true;
      trigger.setAttribute('role','button'); trigger.setAttribute('aria-expanded','false');
      trigger.setAttribute('aria-controls',panel.id); item.removeAttribute('aria-haspopup');
      const bar = document.createElement('li'); bar.className = 'gl2-panel-heading';
      const title = document.createElement('p'); title.className = 'gl2-panel-title'; title.textContent = trigger.textContent.trim();
      const controls = document.createElement('span'); controls.className = 'gl2-panel-controls';
      title.dataset.number=String(index+1).padStart(2,'0');
      const close = document.createElement('button'); close.type='button'; close.className='gl2-menu-close'; close.textContent=labels.close;
      controls.append(close); bar.append(title,controls); panel.prepend(bar);
      const catalogue=panel.querySelector('.gl-catalog-menu');
      const key=categoryKeys[index];
      if(catalogue && key){
        panel.classList.add('gl2-panel-immersive');panel.dataset.gl2Scene=key;
        const poster=catalogue.querySelector('.gl-catalog-menu__poster');
        const scene=poster||document.createElement('figure');
        scene.classList.add('gl2-category-scene');
        if(!poster){scene.setAttribute('aria-hidden','true');catalogue.append(scene);}
        const img=sceneImage(categoryImages[key]);
        img.sizes='(max-width:989px) 0px, (max-width:1200px) calc(100vw - 230px), calc(100vw - 268px)';
        scene.replaceChildren(img);
        catalogue.querySelectorAll('.gl-finder-image').forEach(image=>image.remove());
      }
      close.addEventListener('click',()=>closeDesktop(true));
      return {item,trigger,panel};
    }).filter(Boolean);
    ['mouseover','touchstart','focusin'].forEach(type=>nav.addEventListener(type,event=>{
      if(desktop.matches && entries.some(entry=>entry.item===event.target))event.stopPropagation();
    },true));
    function hidePanel() {
      cancelPotSelection();
      if (!active) return;
      const previous=active; active=null;
      previous.item.removeAttribute('data-gl2-open'); previous.item.classList.remove('nav-hover');
      previous.trigger.setAttribute('aria-expanded','false'); previous.panel.inert=true;
    }
    function closeDesktop(restore=false) {
      hidePanel();if(sheet.open)sheet.close();opener.setAttribute('aria-expanded','false');
      shade.hidden=true;lock(mobileOpen);
      if(restore)opener.focus({preventScroll:true});
    }
    const openDesktop = (entry,focusFirst=false) => {
      rememberScene(sceneFor(active?.panel));
      prepareScene(sceneFor(entry.panel));
      hidePanel();active=entry;
      if(!sheet.open)sheet.showModal();opener.setAttribute('aria-expanded','true');
      entry.panel.inert=false; entry.item.dataset.gl2Open=''; entry.item.classList.add('nav-hover');
      entry.trigger.setAttribute('aria-expanded','true');entry.panel.scrollTop=0;lock(true);
      if(focusFirst) entry.panel.querySelector('.gl-catalog-menu a')?.focus();else entry.trigger.focus({preventScroll:true});
    };
    const warmEntry = entry => {
      warmImage(sceneFor(entry?.panel));
      if (entry?.panel.querySelector('.gl-catalog-menu--pots')) potCards.forEach(card=>warmImage(card.querySelector('img:not(.gl2-scene-hold)')));
    };
    warmImage(sceneFor(entries[0]?.panel));
    ['pointerenter','focus'].forEach(type=>opener.addEventListener(type,()=>warmEntry(entries[0])));
    entries.forEach(entry=>['pointerenter','focus'].forEach(type=>entry.trigger.addEventListener(type,()=>warmEntry(entry))));
    opener.addEventListener('click',()=>openDesktop(entries[0]));
    sheet.addEventListener('cancel',event=>{event.preventDefault();closeDesktop(true);});
    sheet.addEventListener('keydown',event=>{
      if(event.key!=='Tab')return;
      const items=focusables(sheet),first=items[0],last=items[items.length-1];
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
    });
    nav.addEventListener('click',event=>{
      const entry=entries.find(entry=>entry.trigger.contains(event.target));
      if(!desktop.matches || !entry) return;
      event.preventDefault(); event.stopImmediatePropagation();
      openDesktop(entry);
    },true);
    nav.addEventListener('keydown',event=>{
      const entry=entries.find(entry=>entry.trigger===event.target);
      if(!desktop.matches || !entry || !['Enter',' ','ArrowDown'].includes(event.key)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      openDesktop(entry,event.key==='ArrowDown');
    },true);
    shade.addEventListener('click',()=>closeDesktop(true));
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape' && (active||mobileOpen)) {
        event.preventDefault(); event.stopImmediatePropagation();
        if(mobileOpen) requestMobileClose(); else closeDesktop(true);
      }
    },true);
    drawer.setAttribute('role','dialog'); drawer.setAttribute('aria-label',labels.menu); drawer.inert=true;
    const logoRow=drawer.querySelector('.mobile-nav__logo-title--inner');
    logoRow?.prepend(brand()); closeMobile.setAttribute('tabindex','0');
    const mobileTools=document.createElement('div'); mobileTools.className='gl2-mobile-tools';
    const mobileCurrent=document.createElement('span'); mobileCurrent.textContent=labels.menu;
    const back=document.createElement('button'); back.type='button'; back.className='gl2-menu-back'; back.textContent=labels.back; back.hidden=true;
    mobileTools.append(mobileCurrent,back); drawer.querySelector('.mobile-nav__logo-title')?.append(mobileTools);
    const topItems=[...drawer.querySelectorAll('.mobile-nav--main>.top-level')];
    const fruit=drawer.querySelector('a[href$="/collections/superfoods"]');
    const species=fruit?.closest('ul');
    const speciesItem=species?.parentElement;
    const outdoorList=speciesItem?.parentElement;
    if(speciesItem && outdoorList?.matches('ul.mobile-nav__sublist')){
      const allOutdoor=outdoorList.querySelector('a[href$="/collections/outdoor"]')?.closest('li');
      const direct=[...(allOutdoor?[allOutdoor]:[]),...species.children];
      direct.forEach(item=>item.classList.add('gl2-direct-category'));
      outdoorList.prepend(...direct);
      speciesItem.remove();
      outdoorList.classList.add('gl2-outdoor-categories');
    }
    const desktopSpecies=nav.querySelector('a[href$="/collections/superfoods"]')?.closest('.gl-catalog-menu__group');
    if(desktopSpecies){desktopSpecies.classList.add('gl2-primary-category');desktopSpecies.parentElement.prepend(desktopSpecies);}
    const groups=[...drawer.querySelectorAll('.mobile-nav__has-sublist')].map((row,index)=>{
      const list=row.nextElementSibling;
      if(!list?.matches('ul')) return null;
      const link=row.querySelector(':scope > a'); const buttons=[...row.querySelectorAll('button')];
      list.id=`gl2-mobile-group-${index}`; list.hidden=true;
      const controls=link?.getAttribute('href')==='#'?[link,...buttons]:buttons;
      controls.forEach(control=>{control.setAttribute('aria-expanded','false');control.setAttribute('aria-controls',list.id);if(control===link)control.setAttribute('role','button');});
      buttons.forEach(button=>button.setAttribute('aria-label',link.textContent.trim()));
      row.classList.remove('mobile-nav--expanded');
      return {row,list,link,buttons,controls};
    }).filter(Boolean);
    // Keep one independent scene per category: swapping a shared image's src
    // could briefly show a blank or the previous category while it decoded.
    const mobileScenes=topItems.flatMap((top,index)=>{
      const key=categoryKeys[index];
      const group=groups.find(group=>group.row.parentElement===top);
      if(!key || !group)return [];
      const scene=photograph(photos[index],'gl2-mobile-photo');
      scene.dataset.gl2Scene=key;scene.hidden=true;
      const img=scene.querySelector('img');img.fetchPriority='low';
      img.addEventListener('error',()=>scene.classList.add('gl2-mobile-scene-failed'));
      group.row.after(scene);
      return [{top,group,scene,img}];
    });
    let expanded=[];
    const mobileBreadcrumb = () => {
      const current=expanded[expanded.length-1];
      drawer.classList.toggle('gl2-mobile-level-open',Boolean(current));
      topItems.forEach(item=>item.classList.toggle('gl2-mobile-path',Boolean(current && item.contains(current.row))));
      groups.forEach(group=>{
        const inPath=Boolean(current && (group===current || group.list.contains(current.row)));
        group.row.classList.toggle('gl2-mobile-path-row',inPath);
        group.row.parentElement.classList.toggle('gl2-mobile-path',inPath);
        group.list.classList.toggle('gl2-mobile-ancestor-list',inPath && group!==current);
        group.list.classList.toggle('gl2-mobile-current-list',group===current);
      });
      mobileScenes.forEach(({group,scene})=>{scene.hidden=group!==current;});
      back.hidden=!current;
      mobileCurrent.textContent=current?expanded.map(group=>group.link.textContent.trim()).join(' / '):labels.menu;
    };
    const setGroup=(group,open)=>{
      // Retain only the ancestor path, without changing the original lists.
      if(open){
        expanded.filter(item=>item!==group && !item.list.contains(group.row)).forEach(item=>setGroup(item,false));
      }
      group.row.classList.toggle('mobile-nav--expanded',open);group.list.hidden=!open;
      group.controls.forEach(control=>control.setAttribute('aria-expanded',String(open)));
      expanded=expanded.filter(item=>item!==group);
      if(open) expanded.push(group);
      else groups.filter(child=>group.list.contains(child.row)).forEach(child=>{child.row.classList.remove('mobile-nav--expanded');child.list.hidden=true;child.controls.forEach(control=>control.setAttribute('aria-expanded','false'));expanded=expanded.filter(item=>item!==child);});
      mobileBreadcrumb();
    };
    // Keep the section the visitor opened directly below the sticky drawer header.
    // Scrolling does not change focus or navigation order.
    const revealMobileGroup=group=>requestAnimationFrame(()=>{
      if(!mobileOpen || !group.row.isConnected)return;
      if(drawer.classList.contains('gl2-mobile-level-open')){drawer.scrollTo({top:0,behavior:'instant'});return;}
      const bar=drawer.querySelector('.mobile-nav__logo-title');
      const top=drawer.scrollTop+group.row.getBoundingClientRect().top-drawer.getBoundingClientRect().top-(bar?.getBoundingClientRect().height||0)-8;
      drawer.scrollTo({top:Math.max(0,top),behavior:'instant'});
    });
    drawer.addEventListener('click',event=>{
      // Release the navigation dialog before the existing language selector opens its own dialog.
      if(event.target.closest('.md-orbe-custom-selector')){requestMobileClose();syncMobile();return;}
      const group=groups.find(group=>group.controls.some(control=>control.contains(event.target)));
      if(!group)return;
      event.preventDefault();event.stopImmediatePropagation();setGroup(group,group.list.hidden);
      if(!group.list.hidden)focusables(group.list)[0]?.focus({preventScroll:true});
      revealMobileGroup(group);
      if(group.list.hidden && group.buttons.some(button=>button.contains(event.target)))group.buttons[0]?.focus();
    },true);
    drawer.addEventListener('keydown',event=>{
      if((event.key===' '||event.key==='Enter') && event.target.matches('a[role="button"]')){event.preventDefault();event.target.click();}
      if(event.key==='Tab' && mobileOpen){
        const items=focusables(drawer);const first=items[0],last=items[items.length-1];
        if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
      }
    });
    back.addEventListener('click',()=>{const group=expanded[expanded.length-1];if(group){setGroup(group,false);group.controls[0]?.focus({preventScroll:true});revealMobileGroup(group);}});
    function requestMobileClose(){ document.documentElement.dispatchEvent(new CustomEvent('wetheme-toggle-left-drawer',{detail:{forceOpen:false}})); }
    closeMobile.addEventListener('click',event=>{event.preventDefault();requestMobileClose();});
    triggers.forEach(trigger=>trigger.addEventListener('click',()=>{returnTo=trigger;},true));
    const isolate = enabled => {
      if(enabled){
        let node=drawer;
        while(node.parentElement && node.parentElement!==document.documentElement){
          [...node.parentElement.children].filter(sibling=>sibling!==node && sibling.id!=='NavDrawerOverlay' && !['SCRIPT','STYLE','LINK','TEMPLATE'].includes(sibling.tagName)).forEach(sibling=>{if(!inertBackground.has(sibling))inertBackground.set(sibling,sibling.inert);sibling.inert=true;});
          node=node.parentElement;
        }
      } else {inertBackground.forEach((value,node)=>{node.inert=value;});inertBackground.clear();}
    };
    const syncMobile = () => {
      const next=!desktop.matches && document.body.classList.contains('js-drawer-open-left');
      drawer.querySelectorAll('a,button').forEach(el=>{if(!desktop.matches && el!==closeMobile)el.removeAttribute('tabindex');});
      closeMobile.tabIndex=0;
      if(next===mobileOpen)return;
      mobileOpen=next;drawer.inert=!next;triggers.forEach(trigger=>trigger.setAttribute('aria-expanded',String(next)));
      if(next){
        // Prepare mobile-sized scenes on menu opening, never on closed pages.
        mobileScenes.forEach(({img})=>{imageReady(img);});
        mobilePots?.querySelectorAll('.gl2-pot-mobile-link img').forEach(img=>{img.loading='eager';});
        closeDesktop();groups.forEach(group=>setGroup(group,false));drawer.setAttribute('aria-modal','true');isolate(true);lock(true);drawer.scrollTop=0;closeMobile.focus({preventScroll:true});}
      else {drawer.removeAttribute('aria-modal');isolate(false);lock(Boolean(active));if(returnTo && !desktop.matches)returnTo.focus({preventScroll:true});}
    };
    new MutationObserver(syncMobile).observe(document.body,{attributes:true,attributeFilter:['class']});
    desktop.addEventListener('change',()=>{closeDesktop();if(desktop.matches)requestMobileClose();syncMobile();});
    window.addEventListener('resize',()=>{if(active)position();requestAnimationFrame(syncMobile);},{passive:true});
    syncMobile();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

